var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"cancel-title":_vm.defaultCancelTitle,"ok-title":_vm.defaultOkTitle,"title":_vm.title,"ok-variant":"danger"},on:{"ok":function($event){return _vm.confirm()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172182","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CallbackModal.vue
// module id = 3zGZ
// module chunks = 97